export enum RoutingEndpoints {
    login = 'login',
    forgot_password = 'forgot-password',
    reset_user_password = 'external/reset-user-password',
    check_email = 'check-email',
    legal = 'legal',

    signature_pad = 'signature-pad',
    signature_pad_checkin_driver = 'signature-pad-checkin',

    consignor = 'consignor',
    consignor_overview = 'overview',
    consignor_new_folder = 'new-folder',
    consignor_checkout_bundle = 'checkout-bundle',
    consignor_edit_bundle = 'edit-bundle',
    ecmr_editor = 'ecmr-editor',
    ecmr_editor_id = 'ecmr-editor/:id',
    ecmr_editor_id_token_tan = 'ecmr-editor/:id/:userToken/:tan',
    ecmr_editor_id_copy = 'ecmr-editor/:id/copy',
    ecmr_template_editor = 'ecmr-template-editor',
    ecmr_template_editor_id = 'ecmr-template-editor/:id',
    ecmr_history = 'ecmr-history',
    ecmr_history_id_refId = 'ecmr-history/:id/:refId',
    ecmr_anonym_registration = 'ecmr/carrier-registration',
    ecmr_anonym_registration_id_token = 'ecmr/carrier-registration/:id/:userToken',
    ecmr_anonym_registration_success = 'ecmr/carrier-registration-success',
    ecmr_anonym_registration_success_id_token = 'ecmr/carrier-registration-success/:id/:userToken',
    ecmr_anonym_tan_id_token_tan = 'ecmr/ecmr-tan/:id/:userToken/:tan',

    consignee = 'consignee',
    consignee_overview = 'overview',
    consignee_checkin_bundle = 'checkin-bundles',
    consignee_checkin_notes = 'checkin-notes',
    checkin = 'checkin/:folderId',

    carrier = 'spediteur',
    carrier_overview = 'overview',

    spediteur = 'spediteur',
    spediteur_uebersicht = 'overview',

    external = 'external',
    wallet_invite = 'wallet-invite',
    gate = 'gate',
    gate_view = 'gate-view',

    selfservice = 'selfservice',
    selfservice_qrscan = 'qrscan',
    selfservice_handscan = 'handscan',
    selfservice_bundle = 'bundle',
    selfservice_data = 'data',
    selfservice_control = 'control',
    selfservice_pending = 'pending',
    selfservice_configuration = 'configuration',

    settings = 'settings',
    csv_upload = 'csv-upload',
    settings_profile = '',
    settings_email = 'email',
    settings_password = 'password',

    email_got_verified = 'email-success',

    admin = 'admin',
    admin_dashboard = 'dashboard',
}
